import { RefreshResult } from "@idw-types/common";

export enum AxnAdminCacheActionTypes {
    SET_AXN_ADMIN_CACHE_REFRESHING = "SET_AXN_ADMIN_CACHE_REFRESHING",
    SET_AXN_ADMIN_CACHE_REFRESH_RESULTS = "SET_AXN_ADMIN_CACHE_REFRESH_RESULTS"
}

type SetAxnAdminCacheRefreshingAction = {
    type: AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setAxnAdminCacheRefreshing = (isRefreshing: boolean): SetAxnAdminCacheRefreshingAction => ({
    type: AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESHING,
    payload: { isRefreshing }
});

type SetAxnAdminCacheRefreshResultAction = {
    type: AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setAxnAdminCacheRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetAxnAdminCacheRefreshResultAction => ({
    type: AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type AxnAdminCacheActions =
    SetAxnAdminCacheRefreshingAction |
    SetAxnAdminCacheRefreshResultAction